import React from 'react';
import {
  CUSTOM_PRACTICE_HEADER_FIELDS,
  getCustomPracticeTimeValidationError,
  getTimeSelectOptionsForField,
} from '../../utils/customPractice';
import CustomPracticeTimeWheelPicker from './CustomPracticeTimeWheelPicker';
import './CustomPracticeHeaderFields.css';

export default function CustomPracticeHeaderFields({
  meta,
  onFieldChange,
  onFieldCommit,
  disabled = false,
  title = 'Session details',
}) {
  const timeValidationError = getCustomPracticeTimeValidationError(
    meta.start_time,
    meta.end_time
  );
  const endTimeDisabled = disabled || !meta.start_time;

  return (
    <div className="col-12 custom-practice-session-details-block">
      <div className="custom-practice-header">
        <div className="custom-practice-header__body">
          {title ? <p className="custom-practice-header__title">{title}</p> : null}
          <div className="custom-practice-header__grid custom-practice-header__grid--one-row">
            {CUSTOM_PRACTICE_HEADER_FIELDS.map((field) => {
              const isTimeWheel = field.type === 'time-select';
              const isSelect = field.type === 'select';
              const isEndTime = field.key === 'end_time';
              const fieldDisabled = isEndTime ? endTimeDisabled : disabled;
              const timePlaceholder = isEndTime && !meta.start_time
                ? 'Select start time first'
                : field.placeholder;

              return (
                <div className="custom-practice-header__field" key={field.key}>
                  <label
                    className="form-label fw-bolder text-dark fs-6"
                    id={`cp-label-${field.key}`}
                    htmlFor={isTimeWheel ? undefined : `cp-${field.key}`}
                  >
                    {field.label}
                  </label>
                  <div className="custom-practice-header__control">
                    {isTimeWheel ? (
                      <CustomPracticeTimeWheelPicker
                        key={field.key}
                        fieldKey={field.key}
                        value={meta[field.key] ?? ''}
                        placeholder={timePlaceholder}
                        disabled={fieldDisabled}
                        fullWheelLists
                        timeOptions={getTimeSelectOptionsForField(
                          field.key,
                          meta,
                          meta[field.key] ?? ''
                        )}
                        error={Boolean(timeValidationError)}
                        onChange={onFieldChange(field.key)}
                      />
                    ) : isSelect ? (
                      <select
                        id={`cp-${field.key}`}
                        name={field.key}
                        className="form-select form-select-solid form-select-lg"
                        disabled={disabled}
                        value={meta[field.key] ?? ''}
                        onChange={onFieldChange(field.key)}
                        onBlur={onFieldCommit ? () => onFieldCommit() : undefined}
                      >
                        <option value="">{field.placeholder}</option>
                        {(field.options || []).map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        id={`cp-${field.key}`}
                        name={field.key}
                        className="form-control form-control-lg form-control-solid"
                        type="text"
                        disabled={disabled}
                        value={meta[field.key] ?? ''}
                        onChange={onFieldChange(field.key)}
                        onBlur={onFieldCommit ? () => onFieldCommit() : undefined}
                        placeholder={field.placeholder}
                        autoComplete="off"
                      />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          {timeValidationError ? (
            <p className="custom-practice-header__hint text-danger mb-0 mt-2">
              {timeValidationError}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export {
  default as CustomPracticeSessionDuration,
  resolveDurationPartsFromTotalMinutes,
  totalMinutesFromDurationParts,
} from './CustomPracticeSessionDuration';
